import { version } from '../package.json';

type IConfig = {
  ENV: string;
  TOKEN: string;
  BR_ID: string;
  BR_KEY: string;
  RELEASE: string;
  API_URL: string;
  PLACES_API: string;
  MAKE_WH_URL: string;
  MAKE_PP_URL: string;
  MAKE_PAYMENT_BALANCER_URL: string;
  STRIPE_KEY: string;
};

const configs = JSON.parse(atob(process.env.CONFIG as string)) as unknown as {
  staging: IConfig;
  production: IConfig;
};

export const config: IConfig = {
  ...(window.DEBUG ? configs.staging : configs.production),
  ENV: window.DEBUG ? 'staging' : 'production',
  RELEASE: version,
};

console.log(`v${config.RELEASE}`);
